/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Period_LabelInputs */

const vi_order_period_label = /** @type {(inputs: Order_Period_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời gian`)
};

/**

* @param {Order_Period_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_period_label = /** @type {((inputs?: Order_Period_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Period_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_period_label(inputs)
});